var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { staticClass: "portal-root" },
    [
      _c(
        "div",
        { staticClass: "portal-content" },
        [
          _c(
            "div",
            { staticClass: "portal-header-row" },
            [
              _c("h1", { staticClass: "portal-header" }, [
                _vm._v(_vm._s(_vm.$ct("title"))),
              ]),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "user-plus" },
                  on: {
                    click: function ($event) {
                      _vm.inviteModal = true
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("invite-button")) + " ")]
              ),
            ],
            1
          ),
          _c("w-tabs", {
            staticClass: "mb",
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          }),
          _vm.activeTab == 0
            ? _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("dossiers-title"))),
                  ]),
                  _c("w-card-content", [
                    _vm.clientDossiers.length
                      ? _c("table", { staticClass: "dossier-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$ct("col.dossier"))),
                              ]),
                              _c("th", [_vm._v(_vm._s(_vm.$ct("col.client")))]),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$ct("col.integration"))),
                              ]),
                              _c("th", { staticClass: "actions" }),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.clientDossiers, function (d) {
                              return _c("tr", { key: d.DossierID }, [
                                _c("td", [_vm._v(_vm._s(d.DossierName))]),
                                _c("td", [_vm._v(_vm._s(d.CompanyName))]),
                                _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge",
                                      class: _vm.badgeClass(d),
                                    },
                                    [_vm._v(_vm._s(_vm.integrationLabel(d)))]
                                  ),
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "actions" },
                                  [
                                    _c(
                                      "w-menu",
                                      {
                                        attrs: {
                                          value: _vm.openMenuId === d.DossierID,
                                          right: "",
                                          "close-on-blur": "",
                                          width: "240px",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.setMenu(
                                              d.DossierID,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "activator" },
                                            slot: "activator",
                                          },
                                          [
                                            _c(
                                              "w-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value:
                                                      _vm.$ct(
                                                        "tooltip.actions"
                                                      ),
                                                    expression:
                                                      "$ct('tooltip.actions')",
                                                  },
                                                ],
                                              },
                                              [
                                                _c("w-fa", {
                                                  attrs: { icon: "bars" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.openMenuId === d.DossierID
                                          ? _c(
                                              "w-select-item-list",
                                              {
                                                attrs: {
                                                  "rounded-top": "",
                                                  "rounded-bottom": "",
                                                },
                                              },
                                              [
                                                d.IntegrationType == "exact" ||
                                                d.IntegrationType ==
                                                  "clearfacts"
                                                  ? _c(
                                                      "w-select-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.closeMenu()
                                                            _vm.testRunAutoSync(
                                                              d
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "w-row",
                                                          {
                                                            staticClass:
                                                              "menu-row",
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "play",
                                                                "fixed-width":
                                                                  "",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$ct(
                                                                  "tooltip.test-run"
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                d.IntegrationType == "exact"
                                                  ? _c(
                                                      "w-select-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.closeMenu()
                                                            _vm.exportToExact(d)
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "w-row",
                                                          {
                                                            staticClass:
                                                              "menu-row",
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "cloud-upload-alt",
                                                                "fixed-width":
                                                                  "",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$ct(
                                                                  "tooltip.export-exact"
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                d.IntegrationType ==
                                                "clearfacts"
                                                  ? _c(
                                                      "w-select-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.closeMenu()
                                                            _vm.exportToClearfacts(
                                                              d
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "w-row",
                                                          {
                                                            staticClass:
                                                              "menu-row",
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "cloud-upload-alt",
                                                                "fixed-width":
                                                                  "",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$ct(
                                                                  "tooltip.export-clearfacts"
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                d.IntegrationType == "exact"
                                                  ? _c(
                                                      "w-select-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.closeMenu()
                                                            _vm.openUnsynced(d)
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "w-row",
                                                          {
                                                            staticClass:
                                                              "menu-row",
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "clipboard-list",
                                                                "fixed-width":
                                                                  "",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$ct(
                                                                  "tooltip.unsynced"
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.hasSyncLog(d)
                                                  ? _c(
                                                      "w-select-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.closeMenu()
                                                            _vm.openSyncLog(d)
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "w-row",
                                                          {
                                                            staticClass:
                                                              "menu-row",
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "history",
                                                                "fixed-width":
                                                                  "",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$ct(
                                                                  "tooltip.sync-log"
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                d.IntegrationType == "winbooks"
                                                  ? _c(
                                                      "w-select-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.closeMenu()
                                                            _vm.exportToWinbooks(
                                                              d
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "w-row",
                                                          {
                                                            staticClass:
                                                              "menu-row",
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "file-download",
                                                                "fixed-width":
                                                                  "",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$ct(
                                                                  "tooltip.export-winbooks"
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                d.IntegrationType == "yuki"
                                                  ? _c(
                                                      "w-select-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.closeMenu()
                                                            _vm.exportToYuki(d)
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "w-row",
                                                          {
                                                            staticClass:
                                                              "menu-row",
                                                          },
                                                          [
                                                            _c("w-fa", {
                                                              attrs: {
                                                                icon: "cloud-upload-alt",
                                                                "fixed-width":
                                                                  "",
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$ct(
                                                                  "tooltip.export-yuki"
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "w-select-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.closeMenu()
                                                        _vm.createUblArchive(d)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "w-row",
                                                      {
                                                        staticClass: "menu-row",
                                                      },
                                                      [
                                                        _c("w-fa", {
                                                          attrs: {
                                                            icon: "file-archive",
                                                            "fixed-width": "",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "tooltip.ubl-archive"
                                                            )
                                                          )
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "w-select-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.closeMenu()
                                                        _vm.createTicket(d)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "w-row",
                                                      {
                                                        staticClass: "menu-row",
                                                      },
                                                      [
                                                        _c("w-fa", {
                                                          attrs: {
                                                            icon: "life-ring",
                                                            "fixed-width": "",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "tooltip.create-ticket"
                                                            )
                                                          )
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "w-select-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.closeMenu()
                                                        _vm.goToSettings(d)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "w-row",
                                                      {
                                                        staticClass: "menu-row",
                                                      },
                                                      [
                                                        _c("w-fa", {
                                                          attrs: {
                                                            icon: "cog",
                                                            "fixed-width": "",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "tooltip.configure"
                                                            )
                                                          )
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "w-select-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.closeMenu()
                                                        _vm.openDossier(
                                                          d.DossierName
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "w-row",
                                                      {
                                                        staticClass: "menu-row",
                                                      },
                                                      [
                                                        _c("w-fa", {
                                                          attrs: {
                                                            icon: "eye",
                                                            "fixed-width": "",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "tooltip.open-dossier"
                                                            )
                                                          )
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ])
                      : _c("p", [
                          _vm._v(" " + _vm._s(_vm.$ct("no-dossiers")) + " "),
                        ]),
                  ]),
                ],
                1
              )
            : _vm.activeTab == 1
            ? _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("invited-title"))),
                  ]),
                  _c("w-card-content", [
                    _vm.invites.length
                      ? _c("table", { staticClass: "dossier-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$ct("col.invite-target"))),
                              ]),
                              _c("th", [_vm._v(_vm._s(_vm.$ct("col.date")))]),
                              _c("th", [_vm._v(_vm._s(_vm.$ct("col.status")))]),
                              _c("th", { staticClass: "actions" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("col.actions")) + " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.invites, function (i) {
                              return _c("tr", { key: i.ID }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      i.Status == "registered"
                                        ? i.CompanyName || i.Email
                                        : i.Email
                                    )
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.formatDate(i.DateSent))),
                                ]),
                                _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge",
                                      class:
                                        i.Status == "registered"
                                          ? "badge-clearfacts"
                                          : "badge-pending",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            i.Status == "registered"
                                              ? _vm.$ct("status.registered")
                                              : _vm.$ct("status.pending")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "actions" },
                                  [
                                    i.Status == "pending"
                                      ? _c(
                                          "w-button",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$ct(
                                                  "tooltip.cancel-invite"
                                                ),
                                                expression:
                                                  "$ct('tooltip.cancel-invite')",
                                              },
                                            ],
                                            attrs: {
                                              disabled:
                                                _vm.cancelLoadingId == i.ID,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelInvite(i)
                                              },
                                            },
                                          },
                                          [
                                            _c("w-fa", {
                                              attrs: {
                                                icon:
                                                  _vm.cancelLoadingId == i.ID
                                                    ? "spinner"
                                                    : "trash",
                                                spin:
                                                  _vm.cancelLoadingId == i.ID,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ])
                      : _c("p", [
                          _vm._v(" " + _vm._s(_vm.$ct("no-invites")) + " "),
                        ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.ublModal,
            callback: function ($$v) {
              _vm.ublModal = $$v
            },
            expression: "ublModal",
          },
        },
        [
          _vm.ublModal
            ? _c("app-ubl-overview", {
                attrs: {
                  closable: "",
                  "dossier-name": _vm.ublDossier
                    ? _vm.ublDossier.DossierName
                    : "",
                },
                on: {
                  close: function ($event) {
                    _vm.ublModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.exactModal,
            callback: function ($$v) {
              _vm.exactModal = $$v
            },
            expression: "exactModal",
          },
        },
        [
          _vm.exactModal
            ? _c("app-export-to-exact-modal", {
                attrs: {
                  "dossier-name": _vm.exactDossier
                    ? _vm.exactDossier.DossierName
                    : "",
                },
                on: {
                  close: function ($event) {
                    _vm.exactModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.winbooksModal,
            callback: function ($$v) {
              _vm.winbooksModal = $$v
            },
            expression: "winbooksModal",
          },
        },
        [
          _vm.winbooksModal
            ? _c("app-export-to-winbooks-modal", {
                attrs: {
                  "dossier-name": _vm.winbooksDossier
                    ? _vm.winbooksDossier.DossierName
                    : "",
                },
                on: {
                  close: function ($event) {
                    _vm.winbooksModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.yukiModal,
            callback: function ($$v) {
              _vm.yukiModal = $$v
            },
            expression: "yukiModal",
          },
        },
        [
          _vm.yukiModal
            ? _c("app-export-to-yuki-modal", {
                attrs: {
                  "dossier-name": _vm.yukiDossier
                    ? _vm.yukiDossier.DossierName
                    : "",
                },
                on: {
                  close: function ($event) {
                    _vm.yukiModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.clearfactsModal,
            callback: function ($$v) {
              _vm.clearfactsModal = $$v
            },
            expression: "clearfactsModal",
          },
        },
        [
          _vm.clearfactsModal
            ? _c("app-export-to-clearfacts-modal", {
                attrs: {
                  "dossier-name": _vm.clearfactsDossier
                    ? _vm.clearfactsDossier.DossierName
                    : "",
                },
                on: {
                  close: function ($event) {
                    _vm.clearfactsModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.unsyncedModal,
            callback: function ($$v) {
              _vm.unsyncedModal = $$v
            },
            expression: "unsyncedModal",
          },
        },
        [
          _vm.unsyncedModal
            ? _c("app-exact-unsynced-modal", {
                attrs: {
                  "dossier-name": _vm.unsyncedDossier
                    ? _vm.unsyncedDossier.DossierName
                    : "",
                },
                on: {
                  close: function ($event) {
                    _vm.unsyncedModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.syncLogModal,
            callback: function ($$v) {
              _vm.syncLogModal = $$v
            },
            expression: "syncLogModal",
          },
        },
        [
          _vm.syncLogModal
            ? _c("app-exact-sync-log-modal", {
                attrs: {
                  "dossier-id": _vm.syncLogDossier
                    ? _vm.syncLogDossier.DossierID
                    : 0,
                  "dossier-name": _vm.syncLogDossier
                    ? _vm.syncLogDossier.DossierName
                    : "",
                },
                on: {
                  close: function ($event) {
                    _vm.syncLogModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.inviteModal,
            callback: function ($$v) {
              _vm.inviteModal = $$v
            },
            expression: "inviteModal",
          },
        },
        [
          _vm.inviteModal
            ? _c("app-invite-client-modal", {
                on: {
                  close: function ($event) {
                    _vm.inviteModal = false
                  },
                  sent: function ($event) {
                    return _vm.loadInvites()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }